import { render, staticRenderFns } from "./PromotionTierSidebar.vue?vue&type=template&id=535935d6&"
import script from "./PromotionTierSidebar.vue?vue&type=script&lang=js&"
export * from "./PromotionTierSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535935d6')) {
      api.createRecord('535935d6', component.options)
    } else {
      api.reload('535935d6', component.options)
    }
    module.hot.accept("./PromotionTierSidebar.vue?vue&type=template&id=535935d6&", function () {
      api.rerender('535935d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/promotion/PromotionTierSidebar.vue"
export default component.exports